import { useCallback, useEffect, useRef, useState } from 'react';
import { transitionTime } from '../constants/constants';

export type RecentCreations = {
  markCreated: (id: string) => void;
  isNewlyAdded: (id: string) => boolean;
};

export const useRecentCreations = () => {
  const [recent, setRecent] = useState<Set<string>>(new Set());
  const timers = useRef<Map<string, ReturnType<typeof setTimeout>>>(new Map());

  const markCreated = useCallback((id: string) => {
    setRecent((prev) => new Set(prev).add(id));
    if (timers.current.has(id)) {
      clearTimeout(timers.current.get(id));
    }

    const t = setTimeout(() => {
      setRecent((prev) => {
        const next = new Set(prev);
        next.delete(id);
        return next;
      });
      timers.current.delete(id);
    }, transitionTime);

    timers.current.set(id, t);
  }, []);

  const isNewlyAdded = useCallback((id: string) => recent.has(id), [recent]);

  useEffect(() => {
    const timersMap = timers.current;
    return () => {
      timersMap.forEach(clearTimeout);
      timersMap.clear();
    };
  }, []);

  return { markCreated, isNewlyAdded };
};
